/**
 * Binding des offres de livraison
 */
export default [
  {
    value: 'EXP_PICKUP_POINT',
    name: 'Express Relais',
    requiredCompanyName: false,
    requiredPickupPointId: true
  },
  {
    value: 'STD_PRO_PICKUP_POINT',
    name: 'Standard Pro Relais',
    requiredCompanyName: false,
    requiredPickupPointId: true
  },
  {
    value: 'EXP_PRO_PICKUP_POINT',
    name: 'Express Pro Relais',
    requiredCompanyName: false,
    requiredPickupPointId: true
  },
  {
    value: 'STD_PICKUP_POINT',
    name: 'Standard Relais',
    requiredCompanyName: false,
    requiredPickupPointId: true
  },
  {
    value: 'STD_PRO',
    name: 'Standard Livraison Résidentielle',
    requiredCompanyName: false,
    requiredPickupPointId: false
  },
  {
    value: 'STD_PRO_CO',
    name: 'Standard Livraison Entreprise',
    requiredCompanyName: true,
    requiredPickupPointId: false
  },
  {
    value: 'STD_PRO_SIGNATURE',
    name: 'Standard Signature Livraison Résidentielle',
    requiredCompanyName: false,
    requiredPickupPointId: false
  },
  {
    value: 'STD_PRO_SIGN_CO',
    name: 'Standard Signature Livraison Entreprise',
    requiredCompanyName: true,
    requiredPickupPointId: false
  },
  {
    value: 'EXP_PRO',
    name: 'Express Livraison Résidentielle',
    requiredCompanyName: false,
    requiredPickupPointId: false
  },
  {
    value: 'EXP_PRO_CO',
    name: 'Express Livraison Entreprise',
    requiredCompanyName: true,
    requiredPickupPointId: false
  },
  {
    value: 'EXP13_PRO',
    name: 'Express + Livraison Résidentielle',
    requiredCompanyName: false,
    requiredPickupPointId: false
  },
  {
    value: 'EXP13_PRO_CO',
    name: 'Express + Livraison Entreprise',
    requiredCompanyName: true,
    requiredPickupPointId: false
  },
  {
    value: 'EXP10_PRO',
    name: 'Exclusive Livraison Résidentielle',
    requiredCompanyName: false,
    requiredPickupPointId: false
  },
  {
    value: 'EXP10_PRO_CO',
    name: 'Exclusive Livraison Entreprise',
    requiredCompanyName: true,
    requiredPickupPointId: false
  }
];
